<template>
  <div class="w-full h-screen flex flex-col">
    <nav
      v-if="user"
      class="flex justify-between px-4 sm:px-6 py-3 sm:py-4 bg-content-800 flex-shrink-0 z-10"
    >
      <router-link :to="{ name: 'adminDashboard' }" class="button-interactive">
        <img class="w-20 sm:w-24" :src="require('@/assets/logo.png')" alt="" />
      </router-link>

      <div class="flex items-center space-x-2 sm:space-x-4">
        <notification-bell />

        <div class="flex flex-col">
          <p class="text-xs text-right">
            {{ user.email }}
          </p>
          <div class="w-full flex justify-end mt-1">
            <button
              class="button-interactive text-xs w-fit"
              @click="
                $store.dispatch('logout');
                $router.push({ name: 'landing' });
              "
            >
              Cerrar Sesión
            </button>
          </div>
        </div>
      </div>
    </nav>
    <div v-if="user" class="flex flex-1 space-x-2 sm:space-x-4 p-2 sm:p-4 min-h-0">
      <div
        class="flex flex-col flex-shrink-0 w-[50px] sm:w-[180px] rounded-lg text-white sm:px-8 py-4 sm:py-8 border border-primary-500 smooth"
      >
        <router-link
          :to="{ name: 'adminClientsIndex' }"
          class="button-interactive text-xs font-light"
          :class="[{ 'text-primary-500': selectedTab === 'adminClients' }]"
        >
          <div class="flex items-center">
            <client-icon class="w-4 fill-current sm:mr-2 mx-auto sm:mx-0" />
            <span class="hidden sm:block">Clientes</span>
          </div>
        </router-link>

        <router-link
          :to="{ name: 'adminInvestmentsIndex' }"
          class="button-interactive text-xs font-light mt-6"
          :class="[{ 'text-primary-500': selectedTab === 'adminInvestments' }]"
        >
          <div class="flex items-center">
            <investments-icon
              class="w-4 fill-current sm:mr-2 mx-auto sm:mx-0"
            />
            <span class="hidden sm:block">Inversiones</span>
          </div>
        </router-link>

        <router-link
          :to="{ name: 'adminProjectsIndex' }"
          class="button-interactive text-xs font-light mt-6"
          :class="[{ 'text-primary-500': selectedTab === 'adminProjects' }]"
        >
          <div class="flex items-center">
            <projects-icon
              class="w-4 stroke-current sm:mr-2 mx-auto sm:mx-0"
            />
            <span class="hidden sm:block">Proyectos</span>
          </div>
        </router-link>

        <router-link
          :to="{ name: 'adminOpportunitiesIndex' }"
          class="button-interactive text-xs font-light mt-6"
          :class="[{ 'text-primary-500': selectedTab === 'adminOpportunities' }]"
        >
          <div class="flex items-center">
            <opportunities-icon
              class="w-4 stroke-current sm:mr-2 mx-auto sm:mx-0"
            />
            <span class="hidden sm:block">Oportunidades</span>
          </div>
        </router-link>

        <router-link
          :to="{ name: 'adminIntentionsIndex' }"
          class="button-interactive text-xs font-light mt-6"
          :class="[{ 'text-primary-500': selectedTab === 'adminIntentions' }]"
        >
          <div class="flex items-center">
            <intentions-icon
              class="w-4 stroke-current sm:mr-2 mx-auto sm:mx-0"
            />
            <span class="hidden sm:block">Intenciones</span>
          </div>
        </router-link>
      </div>
      <div class="flex-1 min-w-0 overflow-hidden">
        <router-view class="w-full h-full overflow-y-auto" />
      </div>
    </div>
  </div>
</template>

<script>
import BellIcon from "../../../icons/BellIcon";
import AccountIcon from "../../../icons/AccountIcon";
import ClientIcon from "../../../icons/ClientIcon";
import InvestmentsIcon from "../../../icons/InvestmentsIcon";
import OpportunitiesIcon from "../../../icons/OpportunitiesIcon";
import IntentionsIcon from "../../../icons/IntentionsIcon";
import ProjectsIcon from "../../../icons/ProjectsIcon";
import FinancialAdviceIcon from "../../../icons/FinancialAdviceIcon";
import NotificationBell from "../../../components/notifications/NotificationBell";
import { mapState } from "vuex";
export default {
  name: "Dashboard",

  components: {
    BellIcon,
    AccountIcon,
    ClientIcon,
    InvestmentsIcon,
    OpportunitiesIcon,
    IntentionsIcon,
    ProjectsIcon,
    FinancialAdviceIcon,
    NotificationBell,
  },

  computed: {
    ...mapState({
      selectedTab: "selectedTab",
      user: "user",
    }),
  },
};
</script>